export const desktop = 1280;
export const tablet = 768;
export const mobile = 320;